import DefaultLayout from './default';

export default {
    DefaultLayout
} as any;
